import $ from "jquery";

import "../scss/page.scss";

import "../scss/news.scss";

import "jquery-match-height";
import "./scripts/slick/people.js";
import "./scripts/activecampaign-newsletter.js";

if($(location.href.split("#")[1])) {
    var target = $('#'+location.href.split("#")[1]);
    if (target.length) {
      $('html,body').animate({
        scrollTop: target.offset().top - 125
      }, 1000);
    }
}

$('.js-blog-tags-more').each(function(){
    $(this).on('click', function(){
        $(this).hide();
        $(this).closest('.blog__meta').find('.blog__tags-more').addClass('show');
    });
});